import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { StorageService } from '@morningstar/shared/base/storage-service';
import { SyncfusionChartSettingsHelper } from '@morningstar/shared/util';
import { Chart } from '@syncfusion/ej2-angular-charts';
import { filter, shareReplay, startWith, switchMap, tap } from 'rxjs/operators';
import { DashboardBaseComponent } from '../../dashboard-base/dashboard-base.component';
import { MeetingRoomService } from '../meeting-room.service';
import { MeetingRoomUtilization } from './meeting-room-utilization';

@Component({
  selector: 'wsg-meeting-room-utilization',
  templateUrl: './meeting-room-utilization.component.html',
  styleUrls: ['../../dashboard.scss', './meeting-room-utilization.component.css']
})
export class MeetingRoomUtilizationComponent extends DashboardBaseComponent implements OnDestroy, AfterViewInit {

  // == CONSTANTS =======================================================

  title = 'Meeting Room Utilization';
  meetingRoomUtilizationForm: FormGroup;
  @ViewChild('chart') chart: Chart;
  chartSettings = SyncfusionChartSettingsHelper.getBarChartSettings('percentage');

  // == STATE ===========================================================

  form = this.formBuilder.group({
    location: null
  });

  // == INTERMEDIATE ====================================================

  location$ = this.form.get('location').valueChanges.pipe(
    startWith(null)
  );

  utilization$ = this.location$.pipe(
    filter(location => !!location),
    switchMap(location => this.meetingRoomService.getUtilization(location)),
    tap(utilization => this.reloadChart(utilization)),
    shareReplay(1)
  );

  // == LIFECYCLE =======================================================

  constructor(private meetingRoomService: MeetingRoomService,
              private formBuilder: FormBuilder,
              protected storageService: StorageService) {
    super(storageService);
  };

  // == HELPERS =========================================================

  reloadChart(utilization: MeetingRoomUtilization[]) {
    if (this.chart) {
      this.chart.dataSource = utilization;
      this.chart.refresh();
    }
  }
}
